var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsArray, IsBoolean, IsDate, IsEnum, IsNumber, IsOptional, IsString, IsUUID, ValidateNested, } from 'class-validator';
import { AppointmentStatus } from '../../appointments/enums/appointment-status.enum.js';
import { AttendanceOutcome } from '../../appointments/enums/attendance-outcome.enum.js';
import { CancellationOrigin } from '../../appointments/enums/cancellation-origin.enum.js';
import { CopaymentSkipReason } from '../../pvs-billing/enums/copayment-skip-reason.enum.js';
import { PrescriptionNeedBadgeDto } from '../../prescription-validation/dto/prescription-need.dto.js';
import { DeliveryFactFindingDto, LeistungstagDto, } from '../../treatment-plan/dto/delivery-fact.dto.js';
import { PrescriptionFrequency } from '../../treatment-plan/enums/prescription-frequency.enum.js';
import { TreatmentPlanStatus } from '../../treatment-plan/enums/treatment-plan-status.enum.js';
import { TreatmentUnitStatus } from '../../treatment-plan/enums/treatment-unit-status.enum.js';
import { TreatmentPlanTaskViewDto } from './treatment-plan-task-view.dto.js';
export class AuthorizedServiceSummaryEntryDto {
    conceptId;
    abbreviation;
    code;
    /** The prescribed Heilmittelkatalog option (GKV); null without one. Name it with `heilmittelLabel`. */
    optionName;
    count;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], AuthorizedServiceSummaryEntryDto.prototype, "conceptId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], AuthorizedServiceSummaryEntryDto.prototype, "abbreviation", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], AuthorizedServiceSummaryEntryDto.prototype, "code", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], AuthorizedServiceSummaryEntryDto.prototype, "optionName", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], AuthorizedServiceSummaryEntryDto.prototype, "count", void 0);
export class TreatmentLaneCountsDto {
    delivered;
    scheduled;
    planned;
    total;
}
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], TreatmentLaneCountsDto.prototype, "delivered", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], TreatmentLaneCountsDto.prototype, "scheduled", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], TreatmentLaneCountsDto.prototype, "planned", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], TreatmentLaneCountsDto.prototype, "total", void 0);
export class TreatmentLanePerformanceEntryDto {
    conceptId;
    abbreviation;
    code;
    /** The prescribed Heilmittelkatalog option (GKV); null without one. Name it with `heilmittelLabel`. */
    optionName;
    delivered;
    scheduled;
    planned;
    total;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], TreatmentLanePerformanceEntryDto.prototype, "conceptId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], TreatmentLanePerformanceEntryDto.prototype, "abbreviation", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], TreatmentLanePerformanceEntryDto.prototype, "code", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], TreatmentLanePerformanceEntryDto.prototype, "optionName", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], TreatmentLanePerformanceEntryDto.prototype, "delivered", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], TreatmentLanePerformanceEntryDto.prototype, "scheduled", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], TreatmentLanePerformanceEntryDto.prototype, "planned", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], TreatmentLanePerformanceEntryDto.prototype, "total", void 0);
export class TreatmentLaneAppointmentUnitDto {
    treatmentUnitId;
    sequenceInPlan;
    abbreviation;
    code;
    /** The prescribed Heilmittelkatalog option (GKV); null without one. Name it with `heilmittelLabel`. */
    optionName;
    status;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], TreatmentLaneAppointmentUnitDto.prototype, "treatmentUnitId", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], TreatmentLaneAppointmentUnitDto.prototype, "sequenceInPlan", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], TreatmentLaneAppointmentUnitDto.prototype, "abbreviation", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], TreatmentLaneAppointmentUnitDto.prototype, "code", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], TreatmentLaneAppointmentUnitDto.prototype, "optionName", void 0);
__decorate([
    IsEnum(TreatmentUnitStatus),
    Expose(),
    __metadata("design:type", String)
], TreatmentLaneAppointmentUnitDto.prototype, "status", void 0);
export class TreatmentLaneAppointmentDto {
    appointmentId;
    startsAt;
    endsAt;
    /**
     * The appointment's own status. Set by the confirm itself, while its units are
     * delivered by a listener afterwards — so a recorded outcome shows at once.
     */
    status;
    /** The plan's patient's Terminstatus on it (TM-9737): `null` until recorded. */
    attendance;
    /** Who cancelled the plan's patient's participation, read with `attendance`. */
    cancellationOrigin;
    /** `Jonas Weber`; `null` without a therapist. */
    therapistName;
    /** Named by the office location's rooms on the client. */
    roomId;
    officeLocationId;
    units;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], TreatmentLaneAppointmentDto.prototype, "appointmentId", void 0);
__decorate([
    IsDate(),
    Type(() => Date),
    Expose(),
    __metadata("design:type", Date)
], TreatmentLaneAppointmentDto.prototype, "startsAt", void 0);
__decorate([
    IsDate(),
    Type(() => Date),
    Expose(),
    __metadata("design:type", Date)
], TreatmentLaneAppointmentDto.prototype, "endsAt", void 0);
__decorate([
    IsEnum(AppointmentStatus),
    Expose(),
    __metadata("design:type", String)
], TreatmentLaneAppointmentDto.prototype, "status", void 0);
__decorate([
    IsEnum(AttendanceOutcome),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], TreatmentLaneAppointmentDto.prototype, "attendance", void 0);
__decorate([
    IsEnum(CancellationOrigin),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], TreatmentLaneAppointmentDto.prototype, "cancellationOrigin", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], TreatmentLaneAppointmentDto.prototype, "therapistName", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], TreatmentLaneAppointmentDto.prototype, "roomId", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], TreatmentLaneAppointmentDto.prototype, "officeLocationId", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => TreatmentLaneAppointmentUnitDto),
    Expose(),
    __metadata("design:type", Array)
], TreatmentLaneAppointmentDto.prototype, "units", void 0);
export class TreatmentLaneDto {
    counts;
    performance;
    appointments;
    tasks;
    /**
     * One row per Leistungstag, facts nested inside it (#1425 slice 2). Empty for
     * non-GKV plans and for plans whose Verordnung records no Heilmittelkatalog
     * option — there is then no question any kind could raise.
     */
    leistungstage;
    /**
     * Applicable delivery-fact questions across the plan with no recorded answer —
     * what the Therapeut still has to do, shown as the per-day badge. **Not** the
     * readiness signal: an unanswered question is not the same as a day that
     * cannot be billed, and collapsing the two would redefine this number.
     */
    missingFactCount;
    /**
     * Leistungstage that cannot be fully billed — the readiness signal beside the
     * `delivered / scheduled / total` Einheiten bar (#1428). This one is about
     * money: it counts days whose Abrechnungspositionen could not be derived.
     * Only days that have taken place count; a booked day is no verdict yet.
     */
    unbillableLeistungstagCount;
    /**
     * Leistungstage that have taken place. Once the plan has a terminal status
     * these are the whole bill, whether it was worked through or broken off.
     */
    deliveredLeistungstagCount;
    /**
     * When „Abrechnung abschließen" was claimed, or null. A retractable claim of
     * completeness, not a freeze.
     */
    billingFactsCompletedAt;
    /**
     * Advisory, plan-scoped constraint findings: the § 7a Abs. 5 telemedizin quota
     * and the § 7a Abs. 6 written video agreement. **Never blocking** — the same
     * guide-and-judge stance the Heilmittelkatalog validation takes.
     */
    deliveryFactFindings;
    /** The § 7a Abs. 6 written video agreement, and its mid-series revocation. */
    videoConsentAgreedOn;
    videoConsentRevokedOn;
}
__decorate([
    ValidateNested(),
    Type(() => TreatmentLaneCountsDto),
    Expose(),
    __metadata("design:type", TreatmentLaneCountsDto)
], TreatmentLaneDto.prototype, "counts", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => TreatmentLanePerformanceEntryDto),
    Expose(),
    __metadata("design:type", Array)
], TreatmentLaneDto.prototype, "performance", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => TreatmentLaneAppointmentDto),
    Expose(),
    __metadata("design:type", Array)
], TreatmentLaneDto.prototype, "appointments", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => TreatmentPlanTaskViewDto),
    Expose(),
    __metadata("design:type", Array)
], TreatmentLaneDto.prototype, "tasks", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => LeistungstagDto),
    Expose(),
    __metadata("design:type", Array)
], TreatmentLaneDto.prototype, "leistungstage", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], TreatmentLaneDto.prototype, "missingFactCount", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], TreatmentLaneDto.prototype, "unbillableLeistungstagCount", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], TreatmentLaneDto.prototype, "deliveredLeistungstagCount", void 0);
__decorate([
    IsDate(),
    IsOptional(),
    Type(() => Date),
    Expose(),
    __metadata("design:type", Object)
], TreatmentLaneDto.prototype, "billingFactsCompletedAt", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => DeliveryFactFindingDto),
    Expose(),
    __metadata("design:type", Array)
], TreatmentLaneDto.prototype, "deliveryFactFindings", void 0);
__decorate([
    IsDate(),
    IsOptional(),
    Type(() => Date),
    Expose(),
    __metadata("design:type", Object)
], TreatmentLaneDto.prototype, "videoConsentAgreedOn", void 0);
__decorate([
    IsDate(),
    IsOptional(),
    Type(() => Date),
    Expose(),
    __metadata("design:type", Object)
], TreatmentLaneDto.prototype, "videoConsentRevokedOn", void 0);
export class BillingLanePriceRowDto {
    conceptId;
    abbreviation;
    code;
    qty;
    unitPriceGross;
    sumGross;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], BillingLanePriceRowDto.prototype, "conceptId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], BillingLanePriceRowDto.prototype, "abbreviation", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], BillingLanePriceRowDto.prototype, "code", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], BillingLanePriceRowDto.prototype, "qty", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], BillingLanePriceRowDto.prototype, "unitPriceGross", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], BillingLanePriceRowDto.prototype, "sumGross", void 0);
/**
 * The § 302 Zuzahlungs-**Soll** of the Verordnungsblatt (#1499).
 *
 * Exactly one of `amount` / `skipReason` is set. The derivation never guesses:
 * where an input is missing it produces a reason and no figure, and the view
 * shows the reason rather than a number that would be collected from a patient
 * at the desk.
 *
 * The reason travels as the enum and not as prose. The derivation's own `detail`
 * names the offending TreatmentUnit — right for a log and for the § 302 run, and
 * not something to put in front of somebody at the desk. The sentence they read
 * is the frontend's, so there is one German text per reason rather than two to
 * keep in step.
 *
 * The **Ist** — paid when, against which receipt, cash or card — is TM-9443 and
 * is deliberately absent. That is why there is no "offen seit" here.
 */
export class BillingLaneCopaymentDto {
    /** The derived Soll in Euro, or `null` when it could not be derived. */
    amount;
    /** Why no amount could be derived. `null` exactly when `amount` is set. */
    skipReason;
}
__decorate([
    IsNumber(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], BillingLaneCopaymentDto.prototype, "amount", void 0);
__decorate([
    IsEnum(CopaymentSkipReason),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], BillingLaneCopaymentDto.prototype, "skipReason", void 0);
export class BillingLaneDto {
    /** ISO 4217 currency from the pinned price list. null when no estimate could be produced. */
    currency;
    services;
    tasks;
    /**
     * The patient's Zuzahlung for this Verordnung, or `null` where the question
     * does not arise — a PKV or Selbstzahler patient owes the whole invoice, not a
     * share of it.
     */
    copayment;
}
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], BillingLaneDto.prototype, "currency", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => BillingLanePriceRowDto),
    Expose(),
    __metadata("design:type", Array)
], BillingLaneDto.prototype, "services", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => TreatmentPlanTaskViewDto),
    Expose(),
    __metadata("design:type", Array)
], BillingLaneDto.prototype, "tasks", void 0);
__decorate([
    ValidateNested(),
    IsOptional(),
    Type(() => BillingLaneCopaymentDto),
    Expose(),
    __metadata("design:type", Object)
], BillingLaneDto.prototype, "copayment", void 0);
export class SetupLaneDto {
    /**
     * Stammdaten & Validierung lane tasks. Currently the single aggregated
     * `catalog_deviations` task (RS-004) — done when the GKV prescription
     * validates clean against the KBV Heilmittelkatalog, otherwise carrying the
     * deviation count at the worst finding's severity. Empty for non-GKV plans
     * and plans without a captured Diagnosegruppe.
     */
    tasks;
}
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => TreatmentPlanTaskViewDto),
    Expose(),
    __metadata("design:type", Array)
], SetupLaneDto.prototype, "tasks", void 0);
export class TreatmentPlanDetailViewDto {
    id;
    patientId;
    patientName;
    patientIsArchived;
    validUntil;
    status;
    authorizedUnitCount;
    prescriptionDate;
    urgentTreatmentNeeded;
    minWeeklyTherapyFrequency;
    maxWeeklyTherapyFrequency;
    prescriptionFrequency;
    /** Verordnender Arzt — Stammdaten lane (TM-9126). */
    prescribingPhysician;
    lanr;
    bsnr;
    icd10Code;
    diagnosisText;
    /** SDHM Diagnosegruppe code (structured GKV capture, RS-002). */
    diagnosisGroupCode;
    /** Selected Leitsymptomatik codes (a/b/c; multiple allowed). */
    leitsymptomatikCodes;
    /** Patientenindividuelle Leitsymptomatik free text. */
    leitsymptomatikText;
    icd10Code2;
    diagnosisText2;
    /**
     * PayerDomain code for the plan, e.g. 'gkv' | 'bg' | 'beihilfe' | 'pkv' | 'self_pay'.
     * Drives FE branching such as hiding the Eigenanteil block for non-statutory payers.
     * null when the payer code could not be resolved.
     */
    payerKind;
    /**
     * Resolved CaseType name for the sidebar headline. Prefers the plan's explicit
     * caseTypeId, falling back to any case type belonging to the plan's payerDomain
     * (so legacy plans with null caseTypeId still get a label). null when neither
     * lookup matches.
     */
    caseTypeLabel;
    authorizedServiceSummary;
    /**
     * Informational BVB/LHM badges (RS-009) the plan's captured ICDs qualify for,
     * resolved against the SDHMA release valid at the Ausstellungsdatum. A badge,
     * never a violation (fixed decision #6) — empty for non-GKV plans and plans
     * with no qualifying diagnosis.
     */
    prescriptionNeeds;
    setup;
    treatment;
    billing;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], TreatmentPlanDetailViewDto.prototype, "id", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], TreatmentPlanDetailViewDto.prototype, "patientId", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], TreatmentPlanDetailViewDto.prototype, "patientName", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], TreatmentPlanDetailViewDto.prototype, "patientIsArchived", void 0);
__decorate([
    IsDate(),
    IsOptional(),
    Type(() => Date),
    Expose(),
    __metadata("design:type", Object)
], TreatmentPlanDetailViewDto.prototype, "validUntil", void 0);
__decorate([
    IsEnum(TreatmentPlanStatus),
    Expose(),
    __metadata("design:type", String)
], TreatmentPlanDetailViewDto.prototype, "status", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], TreatmentPlanDetailViewDto.prototype, "authorizedUnitCount", void 0);
__decorate([
    IsDate(),
    IsOptional(),
    Type(() => Date),
    Expose(),
    __metadata("design:type", Object)
], TreatmentPlanDetailViewDto.prototype, "prescriptionDate", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], TreatmentPlanDetailViewDto.prototype, "urgentTreatmentNeeded", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], TreatmentPlanDetailViewDto.prototype, "minWeeklyTherapyFrequency", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], TreatmentPlanDetailViewDto.prototype, "maxWeeklyTherapyFrequency", void 0);
__decorate([
    IsEnum(PrescriptionFrequency),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], TreatmentPlanDetailViewDto.prototype, "prescriptionFrequency", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], TreatmentPlanDetailViewDto.prototype, "prescribingPhysician", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], TreatmentPlanDetailViewDto.prototype, "lanr", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], TreatmentPlanDetailViewDto.prototype, "bsnr", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], TreatmentPlanDetailViewDto.prototype, "icd10Code", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], TreatmentPlanDetailViewDto.prototype, "diagnosisText", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], TreatmentPlanDetailViewDto.prototype, "diagnosisGroupCode", void 0);
__decorate([
    IsArray(),
    IsString({ each: true }),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], TreatmentPlanDetailViewDto.prototype, "leitsymptomatikCodes", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], TreatmentPlanDetailViewDto.prototype, "leitsymptomatikText", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], TreatmentPlanDetailViewDto.prototype, "icd10Code2", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], TreatmentPlanDetailViewDto.prototype, "diagnosisText2", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], TreatmentPlanDetailViewDto.prototype, "payerKind", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], TreatmentPlanDetailViewDto.prototype, "caseTypeLabel", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => AuthorizedServiceSummaryEntryDto),
    Expose(),
    __metadata("design:type", Array)
], TreatmentPlanDetailViewDto.prototype, "authorizedServiceSummary", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => PrescriptionNeedBadgeDto),
    Expose(),
    __metadata("design:type", Array)
], TreatmentPlanDetailViewDto.prototype, "prescriptionNeeds", void 0);
__decorate([
    ValidateNested(),
    Type(() => SetupLaneDto),
    Expose(),
    __metadata("design:type", SetupLaneDto)
], TreatmentPlanDetailViewDto.prototype, "setup", void 0);
__decorate([
    ValidateNested(),
    Type(() => TreatmentLaneDto),
    Expose(),
    __metadata("design:type", TreatmentLaneDto)
], TreatmentPlanDetailViewDto.prototype, "treatment", void 0);
__decorate([
    ValidateNested(),
    Type(() => BillingLaneDto),
    Expose(),
    __metadata("design:type", BillingLaneDto)
], TreatmentPlanDetailViewDto.prototype, "billing", void 0);
//# sourceMappingURL=treatment-plan-detail-view.dto.js.map